import { apiClient, assertValidParam } from '@v2/lib';
import type { Partner, PartnerDetails, CreatePartnerPayload } from '@v2/types';

/**
 * Partners Service
 *
 * Domain: Partner organization management
 * Base path: /partners
 *
 * Queries:
 *   - getPartners()          → GET /partners
 *   - getPartnerDetails(id)  → GET /partners/:id
 *
 * Mutations:
 *   - createPartner(payload) → POST /partners
 */

export const partnersService = {
  getPartners: async (): Promise<Partner[]> => {
    const response = await apiClient().get<Partner[]>('partners');
    return response.data;
  },

  getPartnerDetails: async (id: string): Promise<PartnerDetails> => {
    const safeId = assertValidParam(id, 'partnerId');
    const response = await apiClient().get<PartnerDetails>(`partners/${safeId}`);
    return response.data;
  },

  createPartner: async (payload: CreatePartnerPayload): Promise<string> => {
    const response = await apiClient().post<string>('partners', payload);
    return response.data;
  },
};
